module.exports = __webpack_public_path__ + "img/68791bd028d79a90ba498233ef5884b5.png";